import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import HistorialProyecciones from './HistorialProyecciones';

const AjustadorProyecciones = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [registros, setregistros] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [ranchos, setranchos] = useState([]);
    const [selecciones, setselecciones] = useState({ semana: "", rancho: "", num_semanas: 1 });
    const [proyecciones, setproyecciones] = useState({});
    const incluidas = [1, 2, 4, 8, 12, 16, 20];
    const [verHistorial, setverHistorial] = useState(null);
    const columnaStylelg = { width: '120px' };
    const columnaStylemd = { width: '100px' };
    const columnaStylesm = { width: '80px' };


    useEffect(() => {
        getInitialData();
    }, []);

    const getInitialData = async (sel = { ...selecciones }) => {
        const resp = await vr.getDataAPI('campo/v2/proyeccion/ajustes/datos', sel, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        setregistros(resp.data || []);
        setsemanas(resp.semanas || []);
        setranchos(resp.ranchos || []);
        setselecciones({ ...sel, semana: resp.semana_seleccionada || "", num_semanas: resp.num_semanas || 4, rancho: sel.rancho });
        setproyecciones({});
    }

    const ajustarProyeccionDias = (reg, tipo, valor) => {
        const id = reg.id;
        const pro = { ...(proyecciones ?? {}) };
        if (!pro[id]) {
            pro[id] = {
                id: id,
                dias_campo_proyectado: reg.dias_campo_programado,
                tallos_proyeccion: reg.tallos_proyeccion > 0 ?
                    reg.tallos_proyeccion :
                    (
                        reg.tallos_conteo > 0 ?
                            reg.tallos_conteo :
                            reg.tallos_teoricos
                    )
            };
        }

        pro[id][tipo] = valor;
        setproyecciones(pro);
    }

    const proyeccionDias = (registro) => {
        if (proyecciones[registro.id]) {
            return proyecciones[registro.id].dias_campo_proyectado;
        }

        if (vr.int(registro.dias_campo_proyectado, 1) !== false) {
            return registro.dias_campo_proyectado;
        }

        return registro.dias_campo_programado;
    }

    const proyeccionTallos = (registro) => {
        if (proyecciones[registro.id]) {
            return proyecciones[registro.id].tallos_proyeccion;
        }

        if (vr.int(registro.tallos_proyeccion, 1) !== false) {
            return registro.tallos_proyeccion;
        }

        if (vr.int(registro.tallos_conteo, 1) !== false) {
            return registro.tallos_conteo;
        }

        return registro.tallos_teoricos;
    }

    const proyeccionesValidar = () => {
        const ids = Object.keys(proyecciones || {});
        if (ids.length === 0) {
            vr.activeDialog(setdialog, "No hay proyecciones ajustadas para guardar.", "Error", "error");
            return false;
        }

        const revisados = [];
        for (let i = 0; i < ids.length; i++) {
            const data = proyecciones[ids[i]];
            const dias_campo_proyectado = vr.int(data["dias_campo_proyectado"], 1);
            const tallos_proyeccion = vr.int(data["tallos_proyeccion"], 0);

            if (dias_campo_proyectado === false) {
                vr.activeDialog(setdialog, "Los días de campo proyectados que ingreso para al menos un registro son inválidos.", "Error", "error");
                return false;
            }

            if (tallos_proyeccion === false) {
                vr.activeDialog(setdialog, "Los tallos de proyección que ingreso para al menos un registro son inválidos.", "Error", "error");
                return false;
            }
            revisados.push({ id: ids[i], dias_campo_proyectado: dias_campo_proyectado, tallos_proyeccion: tallos_proyeccion });
        }

        return revisados;
    }


    const actualizarProyeccionesServidorDialogo = async () => {
        const payload = proyeccionesValidar();
        if (!payload) return;
        setdialog({
            tipo: "error",
            show: true,
            title: "Confirme para continuar",
            body: `¿Desea guardar las ${payload.length} proyecciones ajustadas?`,
            respYes: "SI, CONTINUAR",
            respNot: "NO, REGRESAR",
            funct: (respVal) => { if (respVal) { actualizarProyeccionesServidor(payload) } setdialog({ show: false }) },
            size: 'm'
        });
    }

    const actualizarProyeccionesServidor = async (payload) => {
        console.log("listo para guardar", { payload })
        const resp = await vr.getDataAPI('campo/v2/proyeccion/ajustes/guardar', { data: payload }, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        vr.activeDialog(setdialog, `Se guardaron las proyecciones ajustadas correctamente.`, "Éxito", "success");
        getInitialData();
    }




    const ajustarProyeccion = (reg, tipo, valor) => {
        const id = reg.id;
        const pro = { ...(proyecciones ?? {}) };
        if (!pro[id]) {
            pro[id] = {
                semana_cosecha_proyeccion: reg.semana_cosecha_proyeccion === "" ? reg.semana_cosecha : reg.semana_cosecha_proyeccion,
                dia_cosecha_proyeccion: reg.dia_cosecha_proyeccion > 0 ? reg.dia_cosecha_proyeccion : reg.dia_cosecha,
                tallos_proyeccion: reg.tallos_proyeccion > 0 ? reg.tallos_proyeccion : (reg.tallos_conteo > 0 ? reg.tallos_conteo : reg.tallos_teoricos),
                error_semana_cosecha_proyeccion: undefined,
                error_dia_cosecha_proyeccion: undefined,
                error_tallos_proyeccion: undefined,
            };
        }
        else { pro[id].error_semana_cosecha_proyeccion = undefined; pro[id].error_dia_cosecha_proyeccion = undefined; pro[id].error_tallos_proyeccion = undefined; }
        pro[id][tipo] = valor;
        setproyecciones(pro);
    }

    const proyeccion = (registro, tipo) => {
        const parseTipo = {
            "semana_cosecha_proyeccion": "semana_cosecha",
            "dia_cosecha_proyeccion": "dia_cosecha",
            "tallos_proyeccion": "tallos_conteo"
        }
        if (proyecciones && proyecciones[registro.id] && proyecciones[registro.id][tipo]) {
            return proyecciones[registro.id][tipo];
        }

        return registro[tipo];
    }

    const estiloProyeccionInput = (id, tipo) => {
        if (!proyecciones || !proyecciones[id] || proyecciones[id][tipo] === undefined) return " border border-2 ";
        if (proyecciones[id][`error_${tipo}`]) return " border border-2 border-danger ";
        return " border border-2 border-warning ";
    }

    const revisarProeycciones = () => {
        const ids = Object.keys(proyecciones || {});
        if (ids.length === 0) {
            vr.activeDialog(setdialog, "No hay proyecciones ajustadas para guardar.", "Error", "error");
            return false;
        }

        const revisados = [];
        const proyctError = { ...proyecciones };
        for (let i = 0; i < ids.length; i++) {
            const data = proyecciones[ids[i]];
            const semana = vr.semanaFloricents(data["semana_cosecha_proyeccion"]);
            let error = false;
            if (!semana) {
                proyctError[ids[i]].error_semana_proyeccion = "Semana de proyección inválida";
                error = true;
            }

            const dia = vr.int(data["dia_cosecha_proyeccion"], 1, 7);
            if (dia === false) {
                proyctError[ids[i]].error_dia_proyeccion = "Día de proyección inválido";
                error = true;
            }

            const tallos = vr.int(data["tallos_proyeccion"], 0);
            if (tallos === false) {
                proyctError[ids[i]].error_tallos_proyeccion = "Tallos de proyección inválido";
                error = true;
            }
            if (error) { continue; }
            revisados.push({ id: ids[i], semana: semana, dia: dia, tallos: tallos });
        }

        if (revisados.length != ids.length) {
            setproyecciones(proyctError);
            vr.activeDialog(setdialog, "Hay errores en las proyecciones ajustadas, se marcarón con rojo los errores, favor de corregirlos antes de guardar.", "Error", "error");
            setproyecciones(proyctError);
            return false;
        }

        return revisados;

    }

    const dialogoConfirmacion = () => {
        const data = revisarProeycciones();
        if (!data) return;
        setdialog({
            tipo: "error",
            show: true,
            title: "Confirme para continuar",
            body: `¿Desea guardar las ${data.length} proyecciones ajustadas?`,
            funct: (respVal) => { if (respVal) { actualizarProyecciones(data) } setdialog({ show: false }) },
            size: 'm'
        });
    }

    const actualizarProyecciones = async (data) => {
        const resp = await vr.getDataAPI('campo/v2/proyeccion/ajustes/guardar', { data: data }, setloader, setdialog);
        if (!resp || !resp.estatus) return;
        vr.activeDialog(setdialog, `Se guardaron las proyecciones ajustadas correctamente.`, "Éxito", "success");
        getInitialData();
    }

    return (<>
        <div className="w mt-1" style={{ '--w': '100%' }}>
            <div className='row justify-content-center w-100 m-0 p-0'>

                <div className="w p-2 " style={{ '--w': '100%' }}>
                    <div className='row justify-content-end w-100 m-0 p-0'>
                        <div className="bw m-1 contenedor-bottom" style={{ '--bw': '200px' }}>
                            {Object.keys(proyecciones || {}).length > 0 &&
                                <button className='btn btn-light btn-sm border border-2 border-warning w-100 shadow text-bold'
                                    onClick={actualizarProyeccionesServidorDialogo}
                                    style={{ borderRadius: "0px" }}>
                                    Guardar proyecciones
                                </button>}
                        </div>
                        <div className="bw m-1" style={{ '--bw': '200px' }}>
                            <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Semana inicial</div>
                            <select className='form-control form-control-sm' placeholder='' onChange={(e) => getInitialData({ ...selecciones, semana: e.target.value })} value={selecciones.semana}>
                                {semanas.map((sem, i) => (
                                    <option key={i} value={sem}>{sem}</option>
                                ))}
                            </select>
                        </div>

                        <div className="bw m-1" style={{ '--bw': '200px' }}>
                            <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Rancho</div>
                            <select className='form-control form-control-sm' onChange={(e) => getInitialData({ ...selecciones, rancho: e.target.value })} value={selecciones.rancho}>
                                <option value='' >Todos los ranchos</option>
                                {ranchos.map((rancho, i) => (
                                    <option key={i + "rancho"} value={rancho.id}>{rancho.nombre}</option>
                                ))}
                            </select>
                        </div>


                        <div className="bw m-1" style={{ '--bw': '200px' }}>
                            <div className="w text-start text-xs text-bold" style={{ '--w': '100%' }}>Semanas incluidas</div>
                            <select className='form-control form-control-sm'
                                onChange={(e) => getInitialData({ ...selecciones, num_semanas: e.target.value })}
                                value={selecciones.num_semanas}>
                                {incluidas.map((num, i) => (
                                    <option key={i + "eer"} value={num}>{num}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <table className='table table-sm text-s table-hover'>
                    <thead>
                        <tr>
                            <th scope='col' className='text-s text-start text-bold'>Bloque</th>
                            <th scope='col' className='text-s text-center text-bold' style={columnaStylelg}>Rancho</th>
                            <th scope='col' className='text-s text-center text-bold' style={columnaStylesm}>Valvula</th>
                            <th scope='col' className='text-s text-center text-bold' style={columnaStylesm}>Tunel</th>
                            <th scope='col' className='text-s text-center text-bold' style={columnaStylesm}>Camas</th>
                            <th scope='col' className='text-s text-center text-bold bw-100'>Programado</th>
                            <th scope='col' className='text-s text-center text-bold bw-100'>Proyectado</th>
                            <th scope='col' className='text-s text-center text-bold' style={columnaStylemd}>Ciclo progr.</th>
                            <th scope='col' className='text-s text-center text-bold bw-100' style={columnaStylesm}>Proy. días</th>
                            <th scope='col' className='text-s text-center text-bold bw-100' style={columnaStylemd}>Proy. tallos</th>
                            {/*<th scope='col' className='text-s text-center text-bold bw-100'>Proy. dia</th>
                            <th scope='col' className='text-s text-center text-bold bw-100'>Proy. tallos</th>*/}
                            <th scope='col' className='text-s text-center text-bold bw-100'>Conteo tallos</th>
                            <th scope='col' className='text-s text-center text-bold bw-100'>Plantas vivas</th>
                            <th scope='col' className='text-s text-center text-bold bw-100'>Historial</th>
                        </tr>
                    </thead>
                    <tbody>
                        {registros.map((reg, i) =>
                            <tr key={i + "reg"}>
                                <td className='text-s text-start text-bold'>{reg.bloque}</td>
                                <td className='text-s text-center' style={columnaStylelg}>{reg.rancho}</td>
                                <td className='text-s text-center' style={columnaStylesm}>{reg.valvula}</td>
                                <td className='text-s text-center' style={columnaStylesm}>{reg.tunel}</td>
                                <td className='text-s text-center' style={columnaStylesm}>{reg.cama_inicio} - {reg.cama_fin}</td>
                                <td className='text-s text-center'>{reg.semana_cosecha}-{reg.dia_cosecha} / {reg.tallos_teoricos}</td>
                                <td className='text-s text-center'>
                                    {reg.semana_cosecha_proyeccion ? reg.semana_cosecha_proyeccion : 'ND'}-{reg.dia_cosecha_proyeccion ? reg.dia_cosecha_proyeccion : 'ND'} / {reg.tallos_proyeccion}
                                </td>
                                <td className='text-s text-center' style={columnaStylemd}>{reg.dias_campo_programado}/{reg.dias_transcurridos}/{reg.dias_faltantes}</td>
                                <td className='text-s text-center bw-100' style={columnaStylesm}>
                                    <input type='number' minLength={0} maxLength={4}
                                        className={`form-control form-control-sm ${estiloProyeccionInput(reg.id, "dias_campo_proyectado")}`}
                                        value={proyeccionDias(reg)}
                                        onChange={(e) => ajustarProyeccionDias(reg, "dias_campo_proyectado", e.target.value)} />
                                </td>
                                <td className='text-s text-center bw-100' style={columnaStylemd}>
                                    <input type='number' minLength={0} maxLength={4}
                                        className={`form-control form-control-sm ${estiloProyeccionInput(reg.id, "tallos_proyeccion")}`}
                                        value={proyeccionTallos(reg)}
                                        onChange={(e) => ajustarProyeccionDias(reg, "tallos_proyeccion", e.target.value)} />
                                </td>
                                {/*
                                <td className='text-s text-center bw-100' style={columnaStylesm}>
                                    <input type='text' minLength={0} maxLength={4}
                                        className={`form-control form-control-sm ${estiloProyeccionInput(reg.id, "semana_cosecha_proyeccion")}`}
                                        value={proyeccion(reg, "semana_cosecha_proyeccion")}
                                        onChange={(e) => ajustarProyeccion(reg, "semana_cosecha_proyeccion", e.target.value)} />
                                </td>
                                <td className='text-s text-center bw-100'>
                                    <input type='number' min={0}
                                        className={`form-control form-control-sm ${estiloProyeccionInput(reg.id, "dia_cosecha_proyeccion")}`}
                                        value={proyeccion(reg, "dia_cosecha_proyeccion")}
                                        onChange={(e) => ajustarProyeccion(reg, "dia_cosecha_proyeccion", e.target.value)}
                                    />
                                </td>
                                <td className='text-s text-center bw-100'>
                                    <input type='number' min={0}
                                        className={`form-control form-control-sm ${estiloProyeccionInput(reg.id, "tallos_proyeccion")}`}
                                        value={proyeccion(reg, "tallos_proyeccion")}
                                        onChange={(e) => ajustarProyeccion(reg, "tallos_proyeccion", e.target.value)}
                                    />
                                </td>*/}
                                <td className='text-s text-center'>{reg.tallos_conteo}</td>
                                <td className='text-s text-center'>{reg.plantas_ejecutadas - reg.plantas_perdidas}</td>
                                <td className='text-s text-center bw-100 align-middle'>
                                    <button className={`btn btn-sm btn-light ${reg.historico.length == 0 ? '' : 'shadow border text-bold'} w-100 pt-0 pb-0`}
                                        onClick={() => setverHistorial({
                                            historico: reg.historico,
                                            semana: reg.semana_cosecha,
                                            dia: reg.dia_cosecha,
                                            tallos: reg.tallos_conteo > 0 ? reg.tallos_conteo : reg.tallos_teoricos,
                                            bloque: reg.bloque
                                        })}
                                        disabled={reg.historico.length == 0}>{reg.historico.length}</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
        {loader && ldr}
        <VainillaDialog data={dialog} />
        {verHistorial && <HistorialProyecciones data={verHistorial} close={() => setverHistorial(null)} />}
    </>)
}

export default AjustadorProyecciones;